import React, { useState } from 'react';
import { Row, Col, Card, Image, Pagination } from 'antd';
import { useLocation } from 'react-router-dom';
import TruncatedText from '../../helpers/TruncatedText';
import CategoryFilesList from '../products/CategoryFilesList';

const DownloadCards = ({ allFiles, handleSelectedProductId, setOpen, categoryId, likedItems, toggleLike }) => {


    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 15;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const paginatedFiles = allFiles?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <>
            <CategoryFilesList
                files={paginatedFiles}
                handleSelectedProductId={handleSelectedProductId}
                setOpen={setOpen}
                categoryId={categoryId}
                likedItems={likedItems}
                toggleLike={toggleLike}
            />
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={allFiles?.length}
                onChange={handlePageChange}
                style={{ textAlign: 'center', marginTop: '20px' }}
            />
        </>
    )
}

export default DownloadCards
